import React from "react";

interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  /** Raises the overlay above an already-open modal (e.g. a validation
   *  message surfaced from inside an edit modal). */
  nested?: boolean;
}

export default function InfoModal({
  isOpen,
  onClose,
  title,
  message,
  confirmLabel = "OK",
  nested = false,
}: InfoModalProps) {
  if (!isOpen) return null;

  return (
    <div className="smrtdocs-modal-overlay" style={nested ? { zIndex: 10000 } : undefined}>
      <div className="smrtdocs-modal" style={{ width: "420px" }}>
        <div className="smrtdocs-modal-header">
          <h2 style={{ margin: 0, fontSize: "1rem" }}>{title}</h2>
        </div>
        <div className="smrtdocs-modal-body">
          <p style={{ fontSize: "0.9rem", lineHeight: 1.5, margin: "0 0 20px", whiteSpace: "pre-line" }}>
            {message}
          </p>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button className="btn-save" onClick={onClose}>{confirmLabel}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
